import classNames, { Value as ClassValue } from "classnames";
import React from "react";
import { serverConstants } from "Shared/Constants";
import { FullDivider } from "./Divider";
import { useDocumentTitle } from "./Hooks/Hooks";
import { MainFooter } from "./MainFooter";
import { MainHeader } from "./MainHeader";

export function LcpUserPageWrapper(props: {
  documentTitle: string;
  onClose?: () => void;
  children: React.ReactNode;
  className?: ClassValue;
  theme?: {
    mainDivStyle?: React.CSSProperties;
  };
}) {
  return (
    <PageWrapper
      {...props}
      header={<MainHeader />}
      footer={<MainFooter />}
      documentTitle={`${props.documentTitle} - ${serverConstants.InsuranceName}`}
    />
  );
}

export function PageWrapper(props: {
  header: React.ReactNode;
  footer: React.ReactNode;
  documentTitle: string;
  onClose?: () => void;
  children: React.ReactNode;
  className?: ClassValue;
  theme?: {
    mainDivStyle?: React.CSSProperties;
  };
}) {
  useDocumentTitle(props.documentTitle);
  return (
    <>
      {props.header}
      <FullDivider />
      <article style={{ margin: "1.5em" }}>
        <div
          className={classNames(props.className)}
          style={{
            maxWidth: "480px",
            margin: "auto",
            ...props.theme?.mainDivStyle,
          }}
        >
          {props.children}
        </div>
      </article>
      {props.footer}
    </>
  );
}
